function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.1523,0,0,1.1559,-6.7194,-2.0252)",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m22.271 25.663c0-1.586 1.4228-2.8721 3.1811-2.8721s3.1811 1.2861 3.1811 2.8721-1.4228 2.8721-3.1811 2.8721-3.1811-1.2861-3.1811-2.8721z",
  fill: "#fff",
  strokeWidth: 1.446
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m25.535 23.468c-1.1567 0-2.0937 0.89609-2.0937 2.0007 0 1.1052 0.93697 2.0007 2.0937 2.0007 1.1568 0 2.0937-0.89552 2.0937-2.0007 0-1.1046-0.93697-2.0007-2.0937-2.0007zm-0.88491-4.8923h1.8103l0.52054 1.6095 1.5558 0.53708 1.5096-0.66058 1.2493 1.1971-0.77502 1.3619 0.60151 1.5274 1.6426 0.53651v1.6509l-1.5963 0.53651-0.64778 1.4033 0.86178 1.5274-1.3823 1.1971-1.5096-0.7433-1.5096 0.61922-0.56102 1.486h-1.8103l-0.56102-1.5274-1.3823-0.53651-1.5963 0.66058-1.2088-1.1557 0.64778-1.5687-0.52054-1.3206-1.6831-0.57786v-1.6095l1.5963-0.57786 0.60729-1.4447-0.78081-1.5274 1.2551-1.1971 1.5963 0.70194 1.5096-0.57786z",
  fill: "#adb9ca",
  strokeWidth: 0.57766
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m25.675 23.468c-1.1568 0-2.0937 0.89609-2.0937 2.0007 0 1.1052 0.93697 2.0007 2.0937 2.0007s2.0937-0.89552 2.0937-2.0007c0-1.1046-0.93697-2.0007-2.0937-2.0007zm-0.88491-4.8923h1.8103l0.52054 1.6095 1.5558 0.53708 1.5096-0.66058 1.2493 1.1971-0.77502 1.3619 0.60151 1.5274 1.6426 0.53651v1.6509l-1.5963 0.53651-0.64778 1.4033 0.86178 1.5274-1.3823 1.1971-1.5096-0.7433-1.5096 0.61922-0.56102 1.486h-1.8103l-0.56102-1.5274-1.3823-0.53651-1.5963 0.66058-1.2088-1.1557 0.64778-1.5687-0.52054-1.3206-1.6831-0.57786v-1.6095l1.5963-0.57786 0.60729-1.4447-0.7808-1.5274 1.2551-1.1971 1.5963 0.70194 1.5096-0.57786z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.86648
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.7261 0 0 .72837 9.679 -.14558)"
}, React.createElement("path", {
  className: "icon-primary",
  d: "m18.417 41.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  opacity: 0.99,
  strokeWidth: 1.4542
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m18.417 41.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8,
  strokeWidth: 1.3751
}), React.createElement("circle", {
  className: "icon-tertiary",
  cx: 18.16,
  cy: 37.876,
  r: 3.2945,
  fill: "#fff",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8,
  strokeWidth: 1.3751
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m6.6199 9.1872c0-1.456 1.1565-2.6372 2.5911-2.6372h12.611c1.4346 0 2.5911 1.1813 2.5911 2.6372v10.551c0 1.456-1.1565 2.6372-2.5911 2.6372h-12.611c-1.4346 0-2.5911-1.1813-2.5911-2.6372z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m8.794 16.185 3.959 4.0503 9.4859-8.7132-2.669-2.8317-6.3944 8.7641-1.9795-3.0476z",
  fill: "#ecaec6",
  strokeWidth: 0.66667
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m8.794 16.185 3.959 4.0503 9.4859-8.7132-2.669-2.8317-6.3944 8.7641-1.9795-3.0476z",
  fill: "none"
}));
var SvgSidepanelDataRules = function SvgSidepanelDataRules(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSidepanelDataRules, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidepanel-data-rules.970dc08d.svg";
export { ForwardRef as ReactComponent };